import React from 'react';
import PropTypes from 'prop-types';
import { WIDGET_GRID_COPY } from '../../constants';
import { Content, Title, List, ListItem } from './Widget.styled';

const Widget = ({ data }) => {
  if (!data) return null;

  const title = data.title || 'Widget';
  const items = data.items || [];

  return (
    <Content>
      <Title>{title}</Title>
      {items.length > 0 ? (
        <List>
          {items.slice(0, 5).map((item) => (
            <ListItem key={item.id || JSON.stringify(item)}>
              {item.content || item.subject || item.description || '-'}
            </ListItem>
          ))}
        </List>
      ) : (
        <p>{WIDGET_GRID_COPY.states.noData}</p>
      )}
    </Content>
  );
};

Widget.propTypes = {
  data: PropTypes.object,
};

Widget.defaultProps = {
  data: null,
};

export default Widget;
